import './LoadingThrobber.scss';
import { BaseClass } from '@components/BaseClass.js';
// not extending component because component imports this utility and this is just a really light / simple class meant to be used by components internally
export class LoadingThrobber extends BaseClass {
    get offline() { return this._offline; }
    set offline(value) {
        this._offline = value;
        this.rootElement?.classList.toggle('offline', value);
    }
    constructor(id, rootElement) {
        super();
        this.mode = '';
        this.progressBarHideDelay = 0;
        this._offline = false;
        this.id = id;
        if (rootElement) {
            this.rootElement = rootElement;
        }
    }
    draw() {
        this.rootElement.classList.add('s360LoadingThrobber', 'throbber-overlay');
        if (this._offline) {
            this.rootElement?.classList.add('offline');
        }
        this.createThrobber();
    }
    createThrobber() {
        this.progressElement = document.createElement('div');
        this.progressElement.className = 'progress-bar';
        this.spinnerElement = document.createElement('div');
        this.spinnerElement.className = 'spinner';
        this.offlineIconElement = document.createElement('i');
        this.offlineIconElement.className = 'material-symbols-outlined offline-icon';
        this.offlineIconElement.textContent = 'cloud_off';
        this.rootElement.classList.add('throbber-overlay');
        this.rootElement.appendChild(this.progressElement);
        this.rootElement.appendChild(this.spinnerElement);
        this.rootElement.appendChild(this.offlineIconElement);
    }
    handleProgress(percent) {
        if (this.mode === 'BAR' || (!this.mode && percent > 0 && percent < 100)) {
            this.showProgressBar(percent);
            if (percent === 100) {
                setTimeout(() => {
                    this.hide();
                }, this.progressBarHideDelay);
            }
        }
        else {
            if (percent === 100) {
                this.hide();
            }
            else {
                this.showSpinner();
            }
        }
    }
    // private adjustThrobberSize() {
    // 	// Get the dimensions of the parent element
    // 	const rect = this.rootElement.getBoundingClientRect();
    //
    // 	// Adjust the throbber's size to match the parent's size.. so it will shrink for smaller things like an input dropdown.
    // 	//this.spinnerElement!.style.width = `${rect.height}px`; // for the pure css version to keep circle from going oval shaped.
    // 	//this.spinnerElement!.style.height = `${rect.height}px`;
    // }
    showProgressBar(percent) {
        this.rootElement.style.display = 'flex';
        this.mode = 'BAR';
        // Update progressElement width based on percent
        if (this.progressElement) {
            this.progressElement.style.width = percent + '%';
            this.spinnerElement.style.display = 'none';
        }
    }
    showSpinner() {
        this.rootElement.style.display = 'flex';
        this.mode = 'SPINNER';
        // Show spinner
        if (this.spinnerElement) {
            this.spinnerElement.style.display = 'block';
            this.progressElement.style.display = 'none';
        }
    }
    hide() {
        // Hide the throbber
        this.rootElement.style.display = 'none';
        if (this.progressElement) {
            this.progressElement.style.display = 'none';
            this.spinnerElement.style.display = 'none';
        }
    }
    destroy() {
        if (this.rootElement && this.rootElement.parentNode) {
            this.rootElement.remove();
        }
        // null out properties for clarity and to aid garbage collection
        this.rootElement = null;
        super.destroy();
    }
}
